import countriesCs from './countries.cs';
import countriesEn from './countries.en';
import countriesDa from './countries.da';
import countriesDe from './countries.de';
import countriesEs from './countries.es';
import countriesFr from './countries.fr';
import countriesHu from './countries.hu';
import countriesNl from './countries.nl';
import countriesPl from './countries.pl';
import countriesPt from './countries.pt';
import countriesRo from './countries.ro';
import countriesSk from './countries.sk';
import countriesSv from './countries.sv';
import countriesUk from './countries.uk';

export let countryForLocales = {
    'en': countriesEn,
    'cs': countriesCs,
    'da': countriesDa,
    'de': countriesDe,
    'es': countriesEs,
    'fr': countriesFr,
    'hu': countriesHu,
    'nl': countriesNl,
    'pl': countriesPl,
    'pt': countriesPt,
    'ro': countriesRo,
    'sk': countriesSk,
    'sv': countriesSv,
    'uk': countriesUk,
};

export function getCountriesForLocale(locale) {
    if (locale in countryForLocales) {
        return countryForLocales[locale];
    }
    return countriesEn;
}
